export default __webpack_public_path__ + "static/media/policy.a3a4f9fb.png";